import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ProjectCard } from "@/components/ProjectCard";
import { ArrowRight, Sparkles, Handshake } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const ProgettiInEvidenza = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/projects?featured=true`).then((r) => r.json()).then((d) => setProjects((d || []).slice(0, 3))).catch(() => {});
  }, []);

  if (!projects.length) return null;

  return (
    <section className="py-16 sm:py-24 bg-white" data-testid="home-progetti">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-[#2E4F3B]/10 border border-[#2E4F3B]/25 px-4 py-1.5 mb-4">
              <Sparkles className="w-3.5 h-3.5 text-[#2E4F3B]" />
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#2E4F3B]">Progetti</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1A1A1A] leading-[1.05] tracking-tight">
              I progetti che <span className="italic font-light text-[#2E4F3B]">stiamo costruendo.</span>
            </h2>
          </div>
          <Link to="/progetti" data-testid="home-progetti-all" className="inline-flex items-center gap-2 rounded-full bg-[#1A1A1A] hover:bg-[#2E4F3B] text-white font-bold px-6 py-3.5 transition-colors shrink-0">
            Scopri tutti i progetti <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p) => <ProjectCard key={p.id} project={p} testidPrefix="home-project" />)}
        </div>

        <div className="mt-12 rounded-3xl bg-gradient-to-br from-[#2E4F3B] to-[#1f2d22] text-white p-8 sm:p-12 flex flex-col sm:flex-row items-start sm:items-center gap-6 justify-between">
          <div className="max-w-xl">
            <Handshake className="w-8 h-8 text-[#E8C9A0] mb-3" />
            <h3 className="font-display text-2xl sm:text-3xl font-black leading-tight">Vuoi costruire uno di questi progetti insieme a noi?</h3>
            <p className="mt-3 text-white/80 text-sm sm:text-base">Aziende, fondazioni, università ed enti: cerchiamo partner e sponsor per trasformare le idee in interventi concreti.</p>
          </div>
          <Link to="/progetti" data-testid="home-progetti-partner" className="inline-flex items-center gap-2 rounded-full bg-[#C15C3D] hover:bg-[#a64830] text-white font-bold px-7 py-4 transition-colors shrink-0">
            Diventa partner di Per Asciano <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
